export default __webpack_public_path__ + "9c180745aa84311fff7367fbbd9afac3.svg";